<template>
  <b-card style="border-left: 10px solid #666;" @click="showModal" :class="{ticket_card: !inModal}">
    <b-row v-if="!!ticket.deleted_at" class="mb-2">
      <b-col>
        <h3 class="text-danger">
          <i class="fa fa-fw fa-exclamation-triangle"></i> {{ trans('deleted') }}
        </h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="col-lg-3 col-12 mb-2 text-center align-self-center" v-if="ticket.meta && ticket.meta.ticket_media_url">
        <img style="width: 100%;" :src="ticket.meta.ticket_media_url" alt="Media Image" />
      </b-col>
      <b-col class="col-lg-6 col-12 mb-2">
        <h2>{{ ticket.class_name }}</h2>
        <p v-if="ticket.meta && ticket.meta.custom_schedule" v-html="ticket.meta.custom_schedule"></p>
        <p v-else>{{ dateRange }}</p>
        <p v-if="ticket.meta && ticket.meta.extra_info">{{ ticket.meta.extra_info }}</p>
        <p v-if="ticket.meta && ticket.meta.seat_name">
          <span v-if="ticket.meta.seat_row">{{ trans('row') }}: {{ ticket.meta.seat_row }} - </span>
          {{trans('seat')}}: {{ ticket.meta.seat_name }}
        </p>
        <p v-if="!noNames">
          {{ ticket.participant_name }}
        </p>
        <p>
          {{ price }}
          <small v-if="ticket.meta && ticket.meta.extra_price_info">{{ ticket.meta.extra_price_info }}</small>
        </p>
      </b-col>
      <b-col class="text-center align-self-center">
        <img v-if="ticket.qr_code_url" :src="ticket.qr_code_url" alt="QR Code" style="max-width: 100%; max-height: 100%;" />
      </b-col>
    </b-row>
  </b-card>
</template>

<style>
 .ticket_card:hover{
    cursor: pointer;
 }
</style>

<script>
  export default {
    props: {
      ticket: {
        type: Object,
      },
      inModal: {
        type: Boolean,
        default: false
      }
    },
    components: {
    },
    data() {
      return{
        moment: moment,
        trans: trans,
      }
    },
    computed: {
      dateRange(){
        return _.timeRangeStr(moment(this.ticket.start), moment(this.ticket.end))
      },
      price(){
        return this.ticket.price <= 0 ? trans('free').toUpperCase() : _.currency(this.ticket.price)
      },
      noNames() {
        return _.get(this.ticket, 'options.do_not_require_names')
      }
    },
    methods: {
      showModal() {
        if (this.inModal) return
        this.$emit('show-modal', this.ticket);
      }
    }
  }
  </script>